import React from "react";
import { Tooltip } from "clearsense-ui/components";

const NavIconWrapper = ({ collapsed, mainLabel, children }) =>
  collapsed ? (
    <Tooltip position="right" content={mainLabel}>
      {children}
    </Tooltip>
  ) : (
    children
  );

export default NavIconWrapper;
